<div class="datatables__wrapper" *ngIf="tableConfig$ | async">
  <agr-extended-notification
    class="screen-only"
    *ngIf="(selectedKpis$ | async).length > canPrintMaxParameters"
    notificationType="warning"
    [title]="'farmer-insights.maxPrintWarning.title' | translate"
    [message]="
      ('farmer-insights.maxPrintWarning.message' | translate) + ' ' + canPrintMaxParameters
    "
  >
  </agr-extended-notification>

  <div class="screen-only">
    <app-table [config]="tableConfig$ | async" class="table"></app-table>
  </div>
  <app-data-view-table-detailed-print
    *ngIf="tableConfig$ | async"
    [config]="tableConfig$"
    [parameters]="parameters"
    [benchmarkSettings]="benchmarkSettings$ | async"
    class="print-only"
  ></app-data-view-table-detailed-print>
</div>
